module.exports = __webpack_public_path__ + "img/upload-cloud.a8ca0015.svg";